angular.module('psModule').controller('SimulationLimitationsModalCtrl', ['$scope', 'pension', function($scope, pension) {
    $scope.pension = pension;
}]);
